import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { BetSlipOfferTimer } from 'src/domains/sportsbook/betting/ui/betSlip/betslipOfferTimer/BetslipOfferTimer';
import { BetslipCombination } from 'src/domains/sportsbook/betting/ui/betSlip/betslipCombination/BetslipCombination';
import { ErrorsAndWarnings } from 'src/domains/sportsbook/betting/ui/betSlip/errorAndWarningMessages/ErrorsAndWarnings';
import { BetSlipButtons } from 'src/domains/sportsbook/betting/ui/betSlip/betSlipButtons/BetSlipButtons';
import { BetslipSpecialMessage } from 'src/domains/sportsbook/betting/ui/betSlip/betslipSpecialMessage/BetslipSpecialMessage';
import { BetslipMultiplesSection } from 'src/domains/sportsbook/betting/ui/betSlip/betslipMultiplesSection/BetslipMultiplesSection';
import { BetslipSinglesSection } from 'src/domains/sportsbook/betting/ui/betSlip/betslipSinglesSection/BetslipSinglesSection';
import {
    BetslipButtonsAndMessageWrapper,
    BetSlipContent,
    CombinationsList,
    ErrorWrapper,
} from './BetslipMainContent.style';
import { CustomKeyboard } from 'src/domains/sportsbook/betting/ui/betSlip/customKeyboard/CustomKeyboard';
import { BetslipYouDecide } from 'src/domains/sportsbook/betting/ui/betSlip/betslipYouDecide/BetslipYouDecide';
import { BetslipMultibet } from 'src/domains/sportsbook/betting/ui/betSlip/betslipMultibet/BetslipMultibet';
import { BetslipBBReferral } from 'src/domains/sportsbook/betting/ui/betSlip/betslipBBReferral/BetslipBBReferral';
import { useAppStateContext } from 'src/appState/AppState';
import { BetslipBonusPopup } from 'src/domains/sportsbook/betting/ui/betSlip/betslipBonus/BetslipBonusPopup';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const BetslipMainContent = observer('BetslipMainContent', () => {
    const {
        appSportsBookState: { betSlipState },
    } = useAppStateContext();
    const {
        combinationsCast2,
        combinationWithoutCast2,
        referralState,
        basicBetSlipState,
        rabState,
        betSlipSummaryState,
    } = betSlipState;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const isMiniCasino = configState.casinoMiniGames;
    const { isVisibleKeyBoard, focusedSelectionId, betSlipSinglesOnly } = basicBetSlipState;
    const { showOfferTimer, hasBBReferral, bbReferralBets } = referralState;
    const combinationId = combinationWithoutCast2[0];

    return (
        <BetSlipContent
            computedHeight={betSlipState.elementRefHeight}
            isVisibleKeyboard={isVisibleKeyBoard && focusedSelectionId !== null}
            isMiniCasino={isMiniCasino}
        >
            {showOfferTimer ? <BetSlipOfferTimer /> : null}

            <BetslipSpecialMessage />

            {betSlipSinglesOnly ? null : (
                <CombinationsList data-test='betslip-forecast-tricast-section'>
                    {combinationsCast2.length > 0
                        ? combinationsCast2.map((combination) => (
                              <BetslipCombination
                                  key={combination.reactKey}
                                  selectionId={combination}
                              />
                          ))
                        : null}
                </CombinationsList>
            )}

            {combinationWithoutCast2.length > 0 && combinationId !== undefined && !betSlipSinglesOnly ? (
                <CombinationsList data-test='betslip-acca-bets-section'>
                    <BetslipCombination selectionId={combinationId} />
                </CombinationsList>
            ) : null}

            {rabState.activeBets2.map((bet) => {
                return (
                    <BetslipYouDecide
                        rabSelectionId={bet}
                        key={bet.reactKey}
                    />
                );
            })}

            {betSlipSummaryState.filteredActiveBets.map((bet) => {
                return (
                    <BetslipMultibet
                        multibetSelectionId={bet}
                        key={bet.reactKey}
                    />
                );
            })}

            {hasBBReferral &&
                bbReferralBets?.map((bbBet, idx) => (
                    <BetslipBBReferral
                        key={`bb-referral-${idx}`}
                        bbBet={bbBet}
                    />
                ))}

            <>
                <BetslipSinglesSection />
                {betSlipSinglesOnly ? null : <BetslipMultiplesSection />}
            </>

            <BetslipButtonsAndMessageWrapper
                computedHeight={betSlipState.elementRefHeight}
                isVisibleKeyboard={isVisibleKeyBoard && focusedSelectionId !== null}
            >
                <ErrorWrapper
                    ref={betSlipState.reactiveWrapper.setRef}
                    variant={configState.componentVariants.betslipVariant}
                >
                    <ErrorsAndWarnings />
                    <BetSlipButtons />
                </ErrorWrapper>
            </BetslipButtonsAndMessageWrapper>

            {betSlipState.isBonusPopupOpen && betSlipState.basicBetSlipState.channel !== 'quickbet' && (
                <BetslipBonusPopup />
            )}

            <CustomKeyboard isQuickBet={false} />
        </BetSlipContent>
    );
});
